import React from 'react';
import { Grid } from '@material-ui/core';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import { NewAnnouncementBanner } from '@procore-oss/backstage-plugin-announcements';
import { Content, Header, Page } from '@backstage/core-components';

export const HomePage = () => {
  return (
    <Page themeId="home">
      <Header title="Home" />

      <Content>
        <Grid container>
          <Grid item xs={12}>
            <NewAnnouncementBanner />
          </Grid>
        </Grid>
        <div style={{ margin: 30 }}>
          <img src={require('./RTL.jpg')} alt="RTL" />
          <h1>Welcome!</h1>
          The goal of this portal is to build a place where users of the
          Developer Platform can find the essential information for their daily
          work. <br />
          <br />
          For everything about the Developer Platform, see the{' '}
          <strong>
            <a href="https://rtltech.atlassian.net/wiki/spaces/DP/pages/1863992495/Homepage">
              Platform documentation <LibraryBooks fontSize="inherit" />
            </a>
          </strong>
          . <br />
          <br />
          It is based on Backstage by Spotify. For more infos please see the{' '}
          <strong>
            <a href="https://backstage.io/">
              Backstage documentation <LibraryBooks fontSize="inherit" />
            </a>
          </strong>
          . <br />
        </div>
      </Content>
    </Page>
  );
};
